<template>
  <v-container class="grey lighten-5">
    <v-row class="justify-start">
      <div class="accordeon-container">
        <div class="d-flex flex-row align-center justify-space-between px-5 py-2 mt-3">
          <div class="d-flex align-center">
            <h3 class="color-darkGray">Multibanco</h3>
          </div>
          <div>
            <v-btn
              v-if="!isButtonVisibilit"
              @click="openDialog()"
              class="br-8"
              height="40"
              color="secondary"
              small
              >Selecionar</v-btn
            >
          </div>
        </div>
        <p class="text-left px-5 py-2 mt-3 color-darkGray">
          Um Link para pagamento ficará disponível ao finalizar o agendamento
        </p>
      </div>
    </v-row>
    <WarningDialog
      ref="warningDialog"
      @ok="onInput"
      text="O pagamento precisa de estar aprovado até 2 horas antes da consulta ser realizada, ou esta
          será automaticamente cancelada. Poderá acompanhar o estado do seu pagamento através dos
          detalhes da consulta agendada. O pagamento é analisado automaticamente, e por isso só
          necessita de acompanhar o processo nos detalhes da consulta."
    />
  </v-container>
</template>

<script>
import WarningDialog from './WarningDialog.vue';

export default {
  components: {
    WarningDialog,
  },
  props: {},
  data() {
    return {
      isButtonVisibilit: false,
    };
  },
  methods: {
    openDialog() {
      const { warningDialog } = this.$refs;
      if (!warningDialog) return;

      warningDialog.openDialog();
    },
    onInput() {
      this.$emit('input', { payment_method_type: 'multibanco' });
      this.isButtonVisibilit = true;
    },
  },
};
</script>

<style scoped>
.accordeon-container {
  width: 100%;
  max-width: 526px;
  background-color: #fffde3;
}
</style>
